module.exports = __webpack_public_path__ + "media/bootstrap-icons/folder-x-399ac43d.svg";